import { api } from './api';

export const galleryService = {
    /**
     * Fetches all gallery images 
     */
    getGalleries: async () => {
        return api.get('/galleries');
    },

    /**
     * Uploads images to the gallery.
     */
    createGallery: async (title, images) => {
        const formData = new FormData();
        formData.append('Title', title);

        images.forEach((image) => {
            formData.append('Images', image);
        });

        return api.post('/galleries', formData);
    },

    /**
     * Deletes 
     */
    deleteGallery: async (id) => {
        return api.delete(`/galleries/${id}`);
    }
};
